import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import Products from './pages/Products';
import NewSale from './pages/NewSale';
import SalesList from './pages/SalesList';
import Invoices from './pages/Invoices';
import Suppliers from './pages/Suppliers';
import Users from './pages/Users';
import Repairs from './pages/Repairs';
import Inventory from './pages/Inventory';
import Debts from './pages/Debts';
import Expenses from './pages/Expenses';

function App() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <AuthProvider>
        <Toaster position="top-right" />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="clients" element={<Clients />} />
            <Route path="products" element={<Products />} />
            <Route path="sales/new" element={<NewSale />} />
            <Route path="sales" element={<SalesList />} />
            <Route path="invoices" element={<Invoices />} />
            <Route path="inventory" element={<Inventory />} />
            <Route path="suppliers" element={<Suppliers />} />
            <Route path="users" element={<Users />} />
            <Route path="debts" element={<Debts />} />
            <Route path="repairs" element={<Repairs />} />
            <Route path="expenses" element={<Expenses />} />
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;